module.exports = __webpack_public_path__ + "sidemenu_icon_on.ac00b37c4bc35e10473a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/sidemenu_icon_on.svg
// module id = 1017
// module chunks = 0